import styled from 'styled-components'

export const StyledCircle = styled.svg`
    transform: rotate(-90deg);
`
